import { isLoggedInSelector } from 'modules/auth';
import React, { useMemo } from 'react';
import { useStore } from 'react-redux';

import Redirect from '@skippay/core/components/Redirect';
import useLocation from '@skippay/core/hooks/useLocation';

const LoggedOutOnly = ({ children }: { children: JSX.Element }): JSX.Element => {
	// This logic should redirect user only on first render, so we dont use
	// reactive `useSelector` but `useStore` with `useMemo` which prevents
	// any more rerender (`reduxStore` shall never change during runtime).
	const reduxStore = useStore();
	const isLoggedIn = useMemo(() => isLoggedInSelector(reduxStore.getState()), [reduxStore]);
	const { defaultPrivateRoot } = useLocation();

	return !isLoggedIn ? children : <Redirect to={{ pathname: defaultPrivateRoot || '/' }} />;
};

export default LoggedOutOnly;
